import axios from "axios";
import { installRequestActivity } from './requestActivity';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
installRequestActivity(api);

export const getDownloadUrl = (path) => `${API}${path}`;
